<div class="input-group position-static" [ngClass]="{'read-only': readOnly || field.disabled}">
  <ng-content></ng-content>
    <button type="button" class="btn btn-outline-light" style="padding: 16px;" (click)="dp.toggle()"
      [attr.aria-label]="toggleButtonLabel"
      [disabled]="field.disabled" [attr.tabindex]="(readOnly || field.disabled) ? '-1' : '0'">
    </button>
</div>